import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdBalance, MdCheckCircle, MdWarning } from 'react-icons/md';

export default class ApuracaoPanel3 extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { loading, dados, nome } = this.props;

        return (
            <>
                {loading ? <Skeleton height={182} variant="rounded" /> :
                    <Stack gap={2}>

                        {/* DIFERENÇA INVENTÁRIO */}
                        <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                            <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" alignItems="center" gap={1} p={1.2}>
                                <MdBalance />
                                <Typography variant="caption"><b>{nome}</b></Typography>
                            </Stack>
                            <Stack direction="row" p={2} gap={4} alignItems="center" flexWrap="wrap">
                                <Box>
                                    <Typography fontSize={10} color="#6b7a92">Diferença</Typography>
                                    <Typography fontSize={22} fontWeight={700}>{dados.diferenca?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                                </Box>
                                <Box flex={1} />
                                <Stack alignItems="flex-start" gap={0.3}>
                                    <Typography fontSize={10} color="#6b7a92">Meta</Typography>
                                    <Typography fontSize={15} fontWeight={600} color="#6b7a92">{dados?.meta?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                                    <Stack direction="row" alignItems="center" gap={0.5} color={dados?.atingida ? '#15803d' : '#b40909'}>
                                        {dados?.atingida ? <MdCheckCircle size={12} /> : <MdWarning size={12} />}
                                        <Typography fontSize={10}>{dados?.atingida ? 'Meta atingida' : 'Meta não atingida'}</Typography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Stack>

                        {/* DIFERENÇA + FORNECEDOR */}
                        <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                            <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" alignItems="center" gap={1} p={1.2}>
                                <MdBalance />
                                <Typography variant="caption"><b>TOTAL DIFERENÇA INVENTÁRIO + DIVERGÊNCIA DE FORNECEDORES</b></Typography>
                            </Stack>
                            <Stack direction="row" p={2} gap={2.5} alignItems="center" flexWrap="wrap">
                                <Box>
                                    <Typography fontSize={10} color="#6b7a92">Diferença inventário</Typography>
                                    <Typography fontSize={15} fontWeight={600} color="#6b7a92">{dados?.diferenca?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                                </Box>
                                <Typography fontSize={20} color="#9ca3af">+</Typography>
                                <Box>
                                    <Typography fontSize={10} color="#6b7a92">DIVERGÊNCIA DE FORNECEDORES</Typography>
                                    <Typography fontSize={15} fontWeight={600} color="#6b7a92">{dados?.divergencia?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                                </Box>
                                <Typography fontSize={20} color="#9ca3af">=</Typography>
                                <Box>
                                    <Typography fontSize={10} color="#6b7a92">Total combinado</Typography>
                                    <Typography fontSize={24} fontWeight={700} color={dados?.totalPositivo ? '#15803d' : '#b91c1c'}>{dados?.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                                </Box>
                            </Stack>
                        </Stack>

                    </Stack>
                }
            </>
        );
    }
}
